<template>

  <form @submit.prevent="onSearch" class="mt-5">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="yearsDropdown && yearsDropdown.length">
          <SelectVue
              v-model="filters.year"
              :options="yearsDropdown"
              :is-clear="true"
              placeholder="Year"
          />
        </div>
      </div>
      <div class="col-lg-2 col-sm-12 col-12">
        <button type="submit" class="btn btn-primary custom_search_button2" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span v-if="!loading">{{ $t('general.button.search') }}</span>
          <span v-else>{{ $t('general.button.search_in_progress') }}</span>
        </button>
      </div>
    </div>
  </form>
  <div class="table-responsive overflow-auto">
    <table class="table table-striped mt-2">
      <thead>
      <tr>
        <th>Erster Urlaubstag</th>
        <th>Letzter Urlaubstag</th>
        <th class="text-right pr-5">Verwendete Urlaubstage</th>
        <th>Typ</th>
        <th class="text-center">Jahr der verwendeten Urlaubstage</th>
        <th>Mitarbeiter</th>
        <th class="text-center">Status</th>
        <th class="text-center">hr bestätigungsstatus</th>
        <th class="text-center">standortleiter bestätigungsstatus</th>
        <th style=" text-align: right; padding-right: 30px; min-width: 150px;">Aktionen</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(holiday, index) in holidays" :key="holiday.id"
          :style="{ backgroundColor: holiday.specialLeave ? '#e4e4e4' : '' }">
        <td>{{ holiday.startDate }}</td>
        <td>{{ holiday.endDate }}</td>
        <td class="text-right pr-5">{{ holiday.requestDays }}</td>
        <td>{{ holiday.typeTranslated }}</td>
        <td class="text-center">
          <!-- Check if holiday type is "special_leave" -->
          <strong v-if="holiday.type === 'special_leave'" class="js-lists-values-employee-name">
            Sonderurlaub
          </strong>

          <!-- If not "special_leave", check other conditions -->
          <strong v-else-if="holiday.year !== null" class="js-lists-values-employee-name">
            {{ holiday.year }}
          </strong>

          <!-- If holiday.year is null, check holiday status -->
          <strong v-else-if="holiday.status === 'approved'" class="js-lists-values-employee-name">
            {{ holiday.uniqueYearsFromItems }}
          </strong>
        </td>
        <td>
          {{ holiday.user.fullName }}
        </td>
        <td class="text-center">
            <span v-if="holiday.status === 'pending'">
               <span class="status-pill yellow p-2 mr-2"
                     data-toggle="tooltip" data-original-title="" title="">
               </span>
            </span>
          <span v-if="holiday.status === 'approved'">
                <span class="status-pill green p-2 mr-2"
                      data-toggle="tooltip" data-original-title="" title="">
               </span>
            </span>
          <span v-if="holiday.status === 'declined'">
               <span class="status-pill red p-2 mr-2"
                     data-toggle="tooltip" data-original-title="" title="">
               </span>
            </span>
          {{ holiday.statusTranslated }}
        </td>
        <td class="text-center" style="min-width: 160px">
          <div class="pl-3">
            <div v-if="holiday.hrApprove === null">
              <div
                  class="status-pill yellow p-2 mr-2"
                  :title="'Anstehend'"
                  data-toggle="tooltip"
                  data-original-title="">
              </div>
              <strong class="js-lists-values-employee-name">Anstehend</strong>
            </div>
            <div v-if="holiday.hrApprove === true">
              <div class="status-pill green p-2 mr-2"
                   data-title="Genehmigt"
                   data-toggle="tooltip" data-original-title="" title="">
              </div>
              <strong class="js-lists-values-employee-name">Genehmigt</strong>
            </div>
            <div v-if="holiday.hrApprove === false">
              <div class="status-pill red p-2 mr-2"
                   data-title="Abgelehnt"
                   data-toggle="tooltip" data-original-title="" title="">
              </div>
              <strong class="js-lists-values-employee-name">Abgelehnt</strong>
            </div>
          </div>
        </td>
        <td class="text-center" style="min-width: 160px">
          <div class="pl-3">
            <div v-if="holiday.coordinatorApprove === null">
              <div
                  class="status-pill yellow p-2 mr-2"
                  :title="'Anstehend'"
                  data-toggle="tooltip"
                  data-original-title="">
              </div>
              <strong class="js-lists-values-employee-name">Anstehend</strong>
            </div>
            <div v-if="holiday.coordinatorApprove === true">
              <div class="status-pill green p-2 mr-2"
                   data-title="Genehmigt"
                   data-toggle="tooltip" data-original-title="" title="">
              </div>
              <strong class="js-lists-values-employee-name">Genehmigt</strong>
            </div>
            <div v-if="holiday.coordinatorApprove === false">
              <div class="status-pill red p-2 mr-2"
                   data-title="Abgelehnt"
                   data-toggle="tooltip" data-original-title="" title="">
              </div>
              <strong class="js-lists-values-employee-name">Abgelehnt</strong>
            </div>
          </div>
        </td>
        <td class="text-right">
          <ActionsButton
              :isOpen="openIndex === index"
              :holiday="holiday"
              :approveLabel="t('general.approve')"
              :approveAsAdminLabel="t('general.approve_as_admin')"
              :approveAsCoordinatorLabel="t('general.approve_as_coordinator')"
              :userRole="piniaCurrentUser.roles[0]"
              @regularHolidayApprove="approveRegularHoliday"
              @specialLeaveApprove="approveSpecialLeave"
              @parentalLeaveApprove="approveParentalLeave"
              @declineRequest="declineHolidayRequest"
              @showHolidaysInRangeModal="handleHolidaysInRangeModal(holiday.id)"
              @showHolidayDetailsModal="handleHolidayDetailsModal(holiday.id)"
              @toggle="toggleDropdown(index)"
          />
        </td>
      </tr>
      </tbody>
    </table>

    <!-- Holidays details modal  -->
    <Modal
        v-model="showHolidayDetailsModal"
        title="Holiday details"
        :hide-cancel="true"
        :hide-footer="true"
        sizeModal="modal-lg"
        classFooter="justify-content-center">
      <HolidayDetailsDataForModal :holidayDetails="holidayDetails"/>
    </Modal>

    <!-- Holidays in range modal  -->
    <Modal
        v-model="showHolidaysInRangeModal"
        title="Holidays in range"
        :hide-cancel="true"
        :hide-footer="true"
        sizeModal="modal-lg"
        classFooter="justify-content-center">
      <HolidaysInRangeDataForModal :holidaysInRange="holidaysInRange"/>
    </Modal>

    <!-- Confirm regular holiday approve -->
    <ModalConfirm
        v-model="showApproveRegularHolidayConfirm"
        :header="approveHeader"
        :onConfirm="confirmApproveRegularHoliday"/>

    <!-- Confirm special leave approve -->
    <ModalConfirm
        v-model="showApproveSpecialLeaveConfirm"
        :header="approveHeader"
        :onConfirm="confirmApproveSpecialLeave"/>

    <!-- Confirm parental leave approve -->
    <ModalConfirm
        v-model="showApproveParentalLeaveConfirm"
        :header="approveHeader"
        :onConfirm="confirmApproveParentalLeave"/>

    <ModalDecline
        v-model="showDeclineModalConfirm"
        :confirmationQuestion="t('general.decline_question')"
        header=""
        :onConfirm="confirmDeclineRequest"/>
  </div>
</template>
<script setup>
import holidayService from '@/api/Holiday';
import Modal from '@/components/modal/Modal.vue';
import ModalConfirm from '@/components/modal/ModalConfirm.vue';
import ModalDecline from '@/components/modal/ModalDecline.vue';
import SelectVue from '@/components/SelectVue.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import { piniaUserStore } from '@/store/piniaUserStore';
import ActionsButton from '@/views/App/Holiday/Overview/List/ActionsButton.vue';
import HolidayDetailsDataForModal from '@/views/App/Holiday/Overview/List/HolidayDetailsDataForModal.vue';
import HolidaysInRangeDataForModal from '@/views/App/Holiday/Overview/List/HolidaysInRangeDataForModal.vue';
import { computed, defineEmits, defineProps, ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

const piniaUserState                   = piniaUserStore();
const piniaCurrentUser                 = computed(() => piniaUserState.currentUser.user);
const { t }                            = useI18n();
const openIndex                        = ref(null);
const showHolidaysInRangeModal         = ref(false);
const showHolidayDetailsModal          = ref(false);
const showApproveRegularHolidayConfirm = ref(false);
const showApproveSpecialLeaveConfirm   = ref(false);
const showApproveParentalLeaveConfirm  = ref(false);
const showDeclineModalConfirm          = ref(false);
const holidaysInRange                  = ref([]);
const holidayDetails                   = ref(null);
const approveRequestData               = ref({});
const approveHeader                    = ref('');

const toggleDropdown = (index) => {
  openIndex.value = openIndex.value === index ? null : index;
};

const props = defineProps({
  holidays: {
    type: Array,
    required: true,
  },
  overviewUserId: {
    type: [ String, null ],
    required: true,
  },
  filters: {
    type: Object,
    required: true,
  },
  yearsDropdown: {
    type: [ Array, null ],
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

// Regular holiday
function approveRegularHoliday(holidayId, approveBy) {
  approveRequestData.value = {
    holidayId,
    approveBy,
  };

  generateApproveHeader(approveBy);
  showApproveRegularHolidayConfirm.value = true;
}

async function confirmApproveRegularHoliday() {
  try {
    await holidayService.approveRegularHoliday(
        approveRequestData.value.holidayId,
        approveRequestData.value.approveBy,
    );

    resetRequestData();
    onSearch();
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    resetRequestData();
    onSearch();
    await ErrorToast(error);
  }
}

// Special leave
function approveSpecialLeave(holidayId, approveBy) {
  approveRequestData.value = {
    holidayId,
    approveBy,
  };

  generateApproveHeader(approveBy);
  showApproveSpecialLeaveConfirm.value = true;
}

async function confirmApproveSpecialLeave() {
  try {
    await holidayService.approveSpecialLeave(
        approveRequestData.value.holidayId,
        approveRequestData.value.approveBy,
    );

    resetRequestData();
    onSearch();
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    resetRequestData();
    onSearch();
    await ErrorToast(error);
  }
}

// Special leave
function approveParentalLeave(holidayId, approveBy) {
  approveRequestData.value = {
    holidayId,
    approveBy,
  };

  generateApproveHeader(approveBy);
  showApproveParentalLeaveConfirm.value = true;
}

async function confirmApproveParentalLeave() {
  try {
    await holidayService.approveParentalLeave(
        approveRequestData.value.holidayId,
        approveRequestData.value.approveBy,
    );

    resetRequestData();
    onSearch();
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    resetRequestData();
    onSearch();
    await ErrorToast(error);
  }
}

// Decline holiday request
function declineHolidayRequest(holidayId) {
  approveRequestData.value = { holidayId };

  showDeclineModalConfirm.value = true;
}

async function confirmDeclineRequest() {
  try {
    await holidayService.declineHolidayRequest(approveRequestData.value.holidayId);

    resetRequestData();
    onSearch();
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    resetRequestData();
    onSearch();
    await ErrorToast(error);
  }
}

function generateApproveHeader(approveBy) {
  if (approveBy === 'admin') {
    approveHeader.value = t('general.approve_as_admin');
  } else if (approveBy === 'coordinator') {
    approveHeader.value = t('general.approve_as_coordinator');
  } else {
    approveHeader.value = t('general.approve');
  }
}

function resetRequestData() {
  openIndex.value                        = null;
  approveRequestData.value               = null;
  showApproveRegularHolidayConfirm.value = false;
  showApproveSpecialLeaveConfirm.value   = false;
  showApproveParentalLeaveConfirm.value  = false;
  showDeclineModalConfirm.value          = false;
}

// Details and in range modals
async function handleHolidaysInRangeModal(holidayId) {
  CloseToast();
  const { data }                 = await holidayService.getOverviewHolidaysInRange(+holidayId);
  holidaysInRange.value          = data.data;
  showHolidaysInRangeModal.value = true;
}

async function handleHolidayDetailsModal(holidayId) {
  CloseToast();
  const { data }                = await holidayService.getOverviewHolidayDetails(+holidayId);
  holidayDetails.value          = data.data;
  showHolidayDetailsModal.value = true;
}

// Emit search event
const emit          = defineEmits([ 'search' ]);
const { filters }   = toRefs(props);
const yearsDropdown = toRefs(props)[ 'yearsDropdown' ];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}
</script>
